module.exports = __webpack_public_path__ + "img/music.32165eb9.png";